export default __webpack_public_path__ + "static/media/dog.08add673.png";